export { default as createInterpolateElement } from './create-interpolate-element';
export * from './react';
export * from './react-platform';
export * from './utils';
export { default as Platform } from './platform';
export { default as renderToString } from './serialize';
export { default as RawHTML } from './raw-html';
//# sourceMappingURL=index.js.map